// extracted by mini-css-extract-plugin
module.exports = {"container":"LogoWall_container__oRzqn global_grid__4e_JW","content":"LogoWall_content__0TVmd","layout":"LogoWall_layout__WPqSz","desktopLayout":"LogoWall_desktopLayout__5BJ38"};